import React, { FC } from 'react';
import { isEmpty } from 'lodash';
import { TArticleInteractionData } from '../Article/ArticleInteractions/types';
import ProtectWithLogin from '../ProtectWithLogin/ProtectWithLogin';
import { LikeButton } from '../LikeButton/LikeButton';
import { TGetModalComponent } from '../Modal/useModal';
import Typo from '../Typography/Typo';
import UsersListModalContent from '../UsersListModal/UsersListModalContent';

type TArticleInspireProps = {
  onInspireClick: () => void;
  isUserInspired: boolean;
  isActionInProgress: boolean;
  usersInspiredByArticle: TArticleInteractionData[];
  totalInspirationsCount: number;
  ModalComponent: TGetModalComponent;
  onArticleInspirationsCounterClick: () => void;
};

// TODO: Rename ArticleInspire to something more generic, to accomodate both articles (posts) and prompts
const ArticleInspire: FC<TArticleInspireProps> = ({
  onInspireClick,
  isUserInspired = false,
  isActionInProgress,
  usersInspiredByArticle = [],
  totalInspirationsCount,
  ModalComponent,
  onArticleInspirationsCounterClick,
}) => (
  <div className="flex items-center">
    <ModalComponent title={`${totalInspirationsCount} likes`}>
      <UsersListModalContent totalCount={totalInspirationsCount} usersList={usersInspiredByArticle} />
    </ModalComponent>
    <ProtectWithLogin>
      <LikeButton
        variant="black"
        stroke="stroke-[1.5px]"
        type="button"
        aria-label="Inspire"
        disabled={isActionInProgress}
        onClick={onInspireClick}
        isActive={isUserInspired}
        isLoading={isActionInProgress}
      />
    </ProtectWithLogin>
    <button type="button" onClick={onArticleInspirationsCounterClick} disabled={isEmpty(usersInspiredByArticle)}>
      <Typo variant="p2" className="min-w-[15px] md:!text-p4 !text-black-700">
        {totalInspirationsCount.toString()}
      </Typo>
    </button>
  </div>
);
export default ArticleInspire;
